var mainSlider;

$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
        window.location.reload()
    }
});

$(function() {
    handleMobileMenu();
    handleHeaderStates();
    handleMegaMenus();
    //handleMenuScroll();
    handleContentVisibilityButtons();
    handlePlayerControl();
    handleLapsSelector();
    handleForms();
    handleIframes();
    handleScroll();
    handleScrollToStep();
    handleCircle();
    handleFields();
    handleLiveChat();
    initLazyLoad();
    initStepsWidget();
    initMapSlider();
    initCounter();
    initRacetrackVideos();
    initProductStats();
    homepageMobileChanges();
    cartClick();
    initShowcaseBlock();
    initUniqueBlock();
    initClampToggles();
    initMediaTextVideos();
});

function initCounter() {
    $('.counter').counterUp({
        delay: 50,
        time: 5000
    });
}

function initStepsWidget() {
    var $stepsTabs = $('.tabs-steps');
    var $stepsContent = $('.b-steps__content');
    $stepsTabs.find('.b-steps__list > li > a.step').hover(function () {
        var self = $(this);
        var tbId = self.attr('href');

        self.find('a').trigger('click');
        $stepsTabs.find('.b-steps__list li').removeClass('active');
        self.closest('li').addClass('active');

        $stepsContent.find('.tab-pane').removeClass('active').addClass('fade');
        $(tbId).addClass('active').addClass('in');
    });

    $stepsContent
        .find('.b-btn__video-play')
        .on('click', function (e) {
            var self = $(this),
                item = self.closest('.item'),
                frameTemplate = item.find('.iframe'),
                playParams = '&autoplay=1',
                videoSrc = '//www.youtube.com/embed/' + frameTemplate.data('id') + '?rel=0&controls=0&showinfo=0' + playParams;

            e.preventDefault();

            // stop all videos
            $stepsContent
                .find('iframe')
                .each(function (i) {
                    var $this = $(this);
                    var src = $this.attr('src');

                    $this.attr('src', src.replace(playParams, ''));
                });

            frameTemplate.replaceWith('<iframe src="' + videoSrc + '" style="border: none;"></iframe>');
            item.find('.img-responsive').hide();
            self.hide();
        });
}



function handleLiveChat() {
    $('.contact-us-chat').click(function(e){
        e.preventDefault();
        Intercom('show');
    });
}

function isMobile() {
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
        return true;
    }
    else {
        return false;
    }
};
    
var player, scrolled = false;

function handleMenuScroll() {
    $("header .main-menu .sub-menu .scroll").mCustomScrollbar({
        theme: "vegassupercars"
    });
}

function onYouTubeIframeAPIReady() {
    var homePageVideo = $('#home-page-slider')[0]
    if(homePageVideo) {
        var observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    initYouTubeVideo(document.getElementById('video-placeholder'));
                    observer.disconnect();
                }
            });
        }, { threshold: 0.5 });

        observer.observe(homePageVideo);
    } else {
        initYouTubeVideo(document.getElementById('video-placeholder'));
    }
}

function initYouTubeVideo(el) {
    var videoId = el.getAttribute('data-video');
    var videoMute = el.getAttribute('data-mute');
    player = new YT.Player('video-placeholder', {
        width: "100%",
        videoId: videoId,
        playerVars: {
            color: 'white',
            autoplay: !el.getAttribute('data-scroll'),
            controls: 0,
            disablekb: 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            showinfo: 0,
            rel: 0,
            mute: videoMute
        },
        events: {
            onReady: function(e) {
                $('.youtube-placeholder').hide();
                if (!el.getAttribute('data-scroll')) {
                    setTimeout(function() {
                        player.playVideo();
                    }, 3000);
                }
            },
            onStateChange: function(e) {
                if (e.data === YT.PlayerState.ENDED) {
                    player.playVideo();
                }
            }
        }
    });
}

function handleFields() {
    $('body').on('blur keyup change click', '.plcaholder-requared .form-control', function() {
        processPlaceholder($(this));
    });
    $('.plcaholder-requared .form-control').each(function() {
        processPlaceholder($(this));
    });
    function processPlaceholder(el) {
        if (el.val() != '') {
            el.addClass('focused');
        } else {
            el.removeClass('focused');
        }
    }
}

function handleIframes() {
    $('.pointer-events').click(function(e) {
        e.stopPropagation();
        $(this).find('.no-pointer-events').removeClass('no-pointer-events');
    });
    $('body').on('click', function() {
        $(this).find('.pointer-events iframe').addClass('no-pointer-events');
    });
}

function handleScroll() {
    $(window).on('resize scroll', function() {
        var $el = $('#video-placeholder');
        if ($el.data('scroll')) {
            var isInViewport = $el.isInViewport();
            if (!scrolled) {
                if (isInViewport) {
                    scrolled = true;
                    player.playVideo();
                }
            }
        }
    });
}

function handlePlayerControl()
{
    $('.soundcontrol').on('click', function () {
        if(player.isMuted()){
             player.unMute();
            $('.soundcontrol').addClass('on');
        } else {
            $('.soundcontrol').removeClass('on');
            player.mute();
        }
    });
}

function handleContentVisibilityButtons() {
    var $lessBtn = $('.lessbtn');
    var $moreBtn = $('.morebtn');

    $lessBtn.click(function () {
        var moreBtn = $('.morebtn').first(),
            target = $('div.more-content').first();

        if (target.is(':visible')) {
            moreBtn.show();
            target.hide(300);
        }

        return false;
    });

    $moreBtn.click(function () {
        var $t = $(this),
            $target = $('div.more-content').first();

        if (undefined !== $target && !$target.is(':visible')) {
            $t.hide();
            $target.show(300);
        }

        return false;
    });
}

/*
 * The off-canvas menu is rendered on every page, including desktop, and is hidden by
 * moving it 20000px off-screen. Off-screen is not hidden as far as the browser is
 * concerned: its 34 links stayed in the tab order and were still read by screen
 * readers, so keyboard users had to pass through a menu they could not see before
 * reaching the page itself.
 *
 * `inert` removes the whole subtree from focus and from the accessibility tree while
 * leaving the slide-in animation untouched. Kept in sync with the `open` class by an
 * observer rather than at each toggle, because the class is flipped from half a dozen
 * places here. Browsers without inert support simply behave as before.
 */
function syncMobileMenuInert() {
    var menu = document.querySelector('.menu-nav');

    if (!menu || !('inert' in HTMLElement.prototype)) {
        return;
    }

    var apply = function () {
        menu.inert = !menu.classList.contains('open');
    };

    apply();

    new MutationObserver(apply).observe(menu, {attributes: true, attributeFilter: ['class']});
}

function handleMobileMenu() {
    syncMobileMenuInert();

    $('.open-menu-nav').on('click', function (e) {
        e.preventDefault();
        $('.menu-nav').addClass('open');
        // Always start at the root: collapse any submenu left open from a previous session
        $('.menu-nav .with-sub, .menu-nav .with-sub-2').removeClass('open');

        if (!$('#supercarts_experiences_mobile_menu_items').data('moved')) {
            $('#supercarts_experiences_mobile_menu_items').insertAfter($('#supercarts_experiences_mobile_menu_list')).removeAttr('style')
            $('#supercarts_experiences_mobile_menu_items').data('moved', true)
        }

        if (!$('#supercars_mobile_menu_items').data('moved')) {
            $('#supercars_mobile_menu_items').insertAfter($('#supercars_mobile_menu_list')).removeAttr('style')
            $('#supercars_mobile_menu_items').data('moved', true)
        }

        if (!$('#gokart_racing_series_mobile_menu_items').data('moved')) {
            $('#gokart_racing_series_mobile_menu_items').insertAfter($('#gokart_racing_series_mobile_menu_list')).removeAttr('style')
            $('#gokart_racing_series_mobile_menu_items').data('moved', true)
        }

        if (!$('#groups_private_mobile_menu_items').data('moved')) {
            $('#groups_private_mobile_menu_items').insertAfter($('#groups_private_mobile_menu_list')).removeAttr('style')
            $('#groups_private_mobile_menu_items').data('moved', true)
        }

        if (!$('#supercars_groups_mobile_menu_items').data('moved')) {
            $('#supercars_groups_mobile_menu_items').insertAfter($('#supercars_groups_mobile_menu_list')).removeAttr('style')
            $('#supercars_groups_mobile_menu_items').data('moved', true)
        }
    });
    $('.menu-nav nav').on('click', function (e) {
        e.stopPropagation();
    });
    $('.menu-nav .close-menu').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.menu-nav').removeClass('open');
        $('.menu-nav .with-sub').removeClass('open');
    });
    $('.menu-nav button, .menu-nav a').on('click', function (e) {
        e.stopPropagation();
        var parent = $(this).parent();
        if(parent.hasClass('with-sub')) {
            e.preventDefault();
            parent.addClass('open');
        }
    });
    $('.menu-nav .close-menu').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.menu-nav').removeClass('open');
        $('.menu-nav .with-sub-2').removeClass('open');
    });
    $('.menu-nav button, .menu-nav a').on('click', function (e) {
        e.stopPropagation();
        var parent = $(this).parent();
        if(parent.hasClass('with-sub-2')) {
            e.preventDefault();
            parent.addClass('open');
        }
    });

    $('.menu-nav').click(function (e) {
        if ($(this).hasClass('open')) {
            $('.menu-nav').removeClass('open');
            $('.menu-nav .with-sub, .menu-nav .with-sub-2').removeClass('open');
        }
    });
    $('.menu-nav .back-menu').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.sub-menu').parent('.with-sub').removeClass('open');
    });
    $('.menu-nav .back-menu-2').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.sub-menu-2').parent('.with-sub-2').removeClass('open');
    });
}


function handleLapsSelector() {
    $('body').on('click', '.booked-item .check-laps input', function() {
        var $el = $(this),
            $lapsContainer = $el.closest('.check-laps'),
            $item = $el.closest('.booked-item');

        if ($item.prev('.booked-item').length == 0) {
            // item is first and not a b1g1
            $lapsContainer.find('.saving-label-normal').show();
            $lapsContainer.find('.saving-label-b1g1').hide();
            $lapsContainer.find('.price-normal').show();
            $lapsContainer.find('.price-b1g1').hide();

            $('label', $lapsContainer).each(function(){
                var priceFull = $(this).find('.price-full').text();
                var priceNormal = $(this).find('.price-normal').text();

                if(priceFull === priceNormal) {
                    $(this).find('.price-full').hide();
                } else {
                    $(this).find('.price-full').show();
                }
            });
        } else {
            // item is b1g1
            $lapsContainer.find('.saving-label-normal').hide();
            $lapsContainer.find('.saving-label-b1g1').show();
            $lapsContainer.find('.price-normal').hide();
            $lapsContainer.find('.price-b1g1').show();

            $('label', $lapsContainer).each(function(){
                var priceFull = $(this).find('.price-full').text();
                var priceB1g1 = $(this).find('.price-b1g1').text();

                if(priceFull === priceB1g1) {
                    $(this).find('.price-full').hide();
                } else {
                    $(this).find('.price-full').show();
                }
            });
        }
        return true;
    });
}

function handleForms() {
    $('body').on('submit', 'form', function() {
        $('.block-layer').show();
    });
}

function handleCircle() {
    var circleTimer = null;
    function setTimer() {
        circleTimer = setTimeout(function() {
            var $el = $('.circle-container .circle-list .circle-item.active'),
                $nextEl = $el.next();
            if ($nextEl.length) {
                $nextEl.trigger('click');
            } else {
               $('.circle-container .circle-list .circle-item').eq(0).trigger('click');
            }
        }, 6000);
    }
    setTimer();
    $('.circle-container .circle-list .circle-item').on('click mouseenter', function() {
        var $el = $(this),
            $contentContainer = $el.closest('.circle-container').find('.circle-content');
        if (!$el.hasClass('active')) {
            clearTimeout(circleTimer);
            setTimer();
            $el.closest('.circle-list').find('.circle-item').removeClass('active');
            $el.addClass('active');
            $contentContainer.find('> div').stop( true, true);
            $contentContainer.find('.active').fadeOut(400, function() {
                $(this).removeClass('active');
                $contentContainer.find('.circe-content-item-' + $el.data('content')).stop( true, true ).fadeIn(400, function() {
                    $(this).addClass('active');
                });
            });
        }
    });
}

function initLazyLoad() {
    $(function() {
        $(".lazy").lazyload({
            effect: "fadeIn",
            placeholder: ''
        });

        $('img.lazy.b-supercar__item__image').on('load', function() {
            var $this = $(this);

            $this
                .closest('.b-supercar__item__image-wrapper')
                .addClass('with-shadow');
        });
    });
}

function initMapSlider() {
    var $mapSlider = $('#map-slider');

    if ($mapSlider.length) {
        $mapSlider.owlCarousel({
            items: 1,
            dots: false,
            loop: true,
            autoplay:true,
            autoplayTimeout:10000,
            autoplaySpeed: 700,
            autoplayHoverPause:true
        });
    }

    $('.b-next.map').click(function () {
        $mapSlider.trigger('next.owl.carousel');
    });
    $('.b-prev.map').click(function () {
        $mapSlider.trigger('prev.owl.carousel');
    });
    $('.b-map-navigation').click(function () {
        $mapSlider.trigger('to.owl.carousel', $(this).data('slide'));
    });
}

function initProductStats() {
    var $productStats = $('.w-product__stats');
    var updatePackageLapsButton = '.update-package-laps';

    $productStats.on('click', updatePackageLapsButton, function () {
        var el = $(this),
            laps = el.data('laps'),
            passengers = el.data('passengers'),

            $select = el
                .closest('form')
                .find('.select-driving-laps'),

            index = el.data('index'),
            type = $select.data('type');

        if (type == 'laps') {
            $select.val(laps);
            setCarPrice(el, index, laps, passengers, passengers);
        } else {
            $select.val(passengers);
            setCarPrice(el, index, laps, passengers, laps);
        }
    });

    $productStats
        .find('.select-driving-laps')
        .on('change', function (e) {
            var el = $(this),
                type = el.data('type'),
                id = el.data('index'),
                val = el.val();

            el.closest('form')
              .find(updatePackageLapsButton)
              .each(function () {
                  $(this).prop('checked', false);
              });
            el.closest('form')
              .find(updatePackageLapsButton + '[data-' + type + '=' + val + ']')
              .prop('checked', true);

            if (val.indexOf('giftpackage-') !== -1) {
                id = val.replace('giftpackage-', '');
            }

            if (type == 'laps') {
                var passengers = $('#laps-passengers-' + id).val();
                setCarPrice(el, id, val, passengers, passengers);
            } else {
                var laps = $('#laps-passengers-' + id).val();
                setCarPrice(el, id, laps, val, laps);
            }
        });
}

function setCarPrice(el, id, laps, passengers, value) {

    $('#laps-passengers-' + id).val(value);

    var form = el.closest('form');
    var $price = form.find('.price-selector .price');
    var $realPrice = $price.find('.real-price');
    var priceContent = 0;

    var checkbox = form.find('input:checked');

    if (checkbox.length > 0) {
        priceContent = $(checkbox[0]).data('price');
    }

    if (priceContent > 0) {
        $realPrice.text('$' + priceContent);
    }
}

function homepageMobileChanges() {
    // Reorder for smaller screens and recenter picture with buggy
    var screenWidth = window.innerWidth;
    if (screenWidth < 769) {
        $(".masonry-exr").insertAfter(".masonry-kart");
        $(".masonry-kart").insertBefore(".masonry-offroad");

        // on screen width 768 background-position x offset must be an -118 to show buggy correct
        // on screen width 340 background-position x offset must be an 0 to show buggy correct
        // those coordinates forms a line. To find correct background-position for any screen width we will use formula find a dot on the line >>> offset = m * screen_width - b
        // m = -118/(768-340) and b = 0 - m*340

        var m = -0.276;
        var b = 0.276*340;

        var background_position = Math.round(m * screenWidth + b);
        if (background_position > 0) {
            background_position = 0;
        }
        $(".masonry-offroad>div").css('background-position', '0px ' + background_position + 'px');
    }
}

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function handleScrollToStep() {
    var $el = $('#'+$('[scrolltoid]').attr('scrolltoid'));
    if ($el.length) {
        //$el[0].scrollIntoView({ behavior: 'smooth' });
        setTimeout(function () {
            $('html, body').stop(true).animate({
                scrollTop: ($el.offset().top) - $('header').outerHeight() - 40
            }, 250);
        }, 250);
    }
}

function cartClick() {
    $('.right-side-cart').click(function(e){
        var cartPrice = $('body').attr('cart-price') || 0;
        cartPrice = parseFloat(cartPrice);
        if (cartPrice > 0) {
            window.location.href = '/checkout';
        }
    });
}

(function () {
    if (typeof Swiper !== 'undefined') {
        document.querySelectorAll('.swiper-custom[data-swiper]').forEach(function (el) {
            try {
                let dataSwiper = el.getAttribute('data-swiper');
                if (!dataSwiper) return;

                let swiperOptions = JSON.parse(dataSwiper);
                if (typeof swiperOptions !== 'object' || swiperOptions === null) return;

                new Swiper(el, swiperOptions);
            } catch (e) {
                console.log('Error initializing Swiper:', e);
            }
        });
    }
})();
/**
 * EX-3423. The row of category labels scrolls sideways on a phone rather than
 * wrapping onto a second line. The row is the scroller itself, so the hint that
 * there is more of it hangs on the element around it, and only on the side that
 * still has somewhere to go.
 *
 * Returns a function that brings a label into view: a label the carousel has
 * just moved to is of no use sitting off the edge of the screen.
 */
function initTabRow(block, prefix) {
    var nav = block.querySelector('.' + prefix + '__nav');
    var row = block.querySelector('.' + prefix + '__tabs');

    if (!nav || !row) {
        return function () {};
    }

    function update() {
        var slack = row.scrollWidth - row.clientWidth;

        nav.classList.toggle('has-prev', slack > 1 && row.scrollLeft > 1);
        nav.classList.toggle('has-next', slack > 1 && row.scrollLeft < slack - 1);
    }

    row.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();

    return function (tab) {
        var left = tab.offsetLeft;
        var right = left + tab.offsetWidth;

        if (left < row.scrollLeft) {
            row.scrollLeft = left - 20;
        } else if (right > row.scrollLeft + row.clientWidth) {
            row.scrollLeft = right - row.clientWidth + 20;
        }

        update();
    };
}

/**
 * EX-3423. The carousel track is as wide as the window, so that a card slid
 * past leaves by the edge of the screen instead of being cut off on the content
 * margin. The first card still has to line up with the content and the last one
 * has to be able to reach that same line, so both offsets are measured off the
 * row of labels, which sits on it.
 */
function updateCarouselOffsets(block, prefix, swiper, container) {
    var slide = container.querySelector('.swiper-slide');
    var ref = block.querySelector('.' + prefix + '__nav');

    if (!slide || !ref) {
        return;
    }

    var gutter = Math.max(0, ref.getBoundingClientRect().left - container.getBoundingClientRect().left);

    swiper.params.slidesOffsetBefore = gutter;
    swiper.params.slidesOffsetAfter = Math.max(0, container.clientWidth - gutter - slide.offsetWidth);
    swiper.update();
}

/* how long the copy takes to open or shut, matching the transition in the css */
var SV_CLAMP_DURATION = 350;

/**
 * EX-3423. The line clamp cannot be animated - a paragraph goes from three
 * lines to all of them in one frame - so the height is driven from here
 * instead: the copy is pinned at the height it has now, the clamp is taken off
 * or put back, and the height is then run to the one the copy wants. The css
 * carries that on a transition and clips the copy to it on the way.
 *
 * Anyone who has asked their system to keep animation down gets the plain jump.
 */
function toggleClampedCopy(copy, open) {
    var quiet = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (quiet) {
        copy.classList.toggle('is-expanded', open);

        return;
    }

    window.clearTimeout(copy.svClampTimer);

    copy.classList.add('is-animating');
    copy.style.maxHeight = copy.clientHeight + 'px';

    /* read it back, or the browser goes straight to the end height */
    void copy.offsetHeight;

    var target;

    if (open) {
        copy.classList.add('is-expanded');
        target = copy.scrollHeight;
    } else {
        /* the clamped height, measured with the clamp on and then put back */
        copy.classList.remove('is-expanded');
        target = copy.clientHeight;
        copy.classList.add('is-expanded');
    }

    copy.style.maxHeight = target + 'px';

    copy.svClampTimer = window.setTimeout(function () {
        copy.classList.toggle('is-expanded', open);
        copy.classList.remove('is-animating');
        copy.style.maxHeight = '';
    }, SV_CLAMP_DURATION);
}

/**
 * EX-3423. "Show More" opens the copy where it stands and turns into
 * "Show Less". It is of no use when the copy is not cut off in the first place,
 * so it is hidden then, and that is worked out again on resize: how many lines
 * a paragraph takes changes with the width of the card it sits in.
 */
function initClampToggles() {
    ['sv-showcase', 'sv-unique'].forEach(function (prefix) {
        initClampToggle(prefix);
    });
}

function initClampToggle(prefix) {
    var pairs = [];

    Array.prototype.forEach.call(document.querySelectorAll('.' + prefix + '__more'), function (button) {
        var box = button.closest('.' + prefix + '__card-body') || button.closest('.' + prefix + '__intro');
        var copy = box && box.querySelector('.' + prefix + '__card-text, .' + prefix + '__text');

        if (!copy) {
            return;
        }

        var pair = {
            button: button,
            copy: copy,
            more: button.textContent.trim(),
            less: button.getAttribute('data-less') || 'Show Less'
        };

        button.setAttribute('aria-expanded', 'false');

        button.addEventListener('click', function (e) {
            e.preventDefault();

            var open = !copy.classList.contains('is-expanded');

            toggleClampedCopy(copy, open);

            button.textContent = open ? pair.less : pair.more;
            button.setAttribute('aria-expanded', open ? 'true' : 'false');

            /* the card has just grown or shrunk under swiper's feet */
            var carousel = button.closest('.swiper-container');

            if (carousel && carousel.swiper) {
                window.setTimeout(function () {
                    carousel.swiper.update();
                }, SV_CLAMP_DURATION);
            }
        });

        pairs.push(pair);
    });

    if (!pairs.length) {
        return;
    }

    function refresh() {
        pairs.forEach(function (pair) {
            if (pair.copy.classList.contains('is-expanded') ||
                pair.copy.classList.contains('is-animating')) {
                return;
            }

            pair.button.classList.toggle('is-hidden', pair.copy.scrollHeight <= pair.copy.clientHeight + 1);
        });
    }

    var pending;

    window.addEventListener('resize', function () {
        clearTimeout(pending);
        pending = setTimeout(refresh, 150);
    });

    refresh();

    /* the web font lands after the first pass and moves the line breaks */
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(refresh);
    }
}

/**
 * EX-3369. Driving experiences showcase (cms block "mainpage_showcase").
 * The category labels work as the carousel navigation: a click slides to the
 * matching card and the active label follows the current slide.
 */
function initShowcaseBlock() {
    if (typeof Swiper === 'undefined') {
        return;
    }

    $('.sv-showcase').each(function () {
        var block = this;
        var container = block.querySelector('.sv-showcase__carousel');

        if (!container || container.swiper) {
            return;
        }

        var tabs = Array.prototype.slice.call(block.querySelectorAll('.sv-showcase__tab'));
        var showTab = initTabRow(block, 'sv-showcase');

        var swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 35,
            speed: 500,
            watchOverflow: true,
            grabCursor: true,
            navigation: {
                nextEl: block.querySelector('.sv-showcase__arrow--next'),
                prevEl: block.querySelector('.sv-showcase__arrow--prev')
            },
            pagination: {
                el: block.querySelector('.sv-showcase__dots'),
                clickable: true
            },
            breakpoints: {
                600: {
                    spaceBetween: 16
                },
                991: {
                    spaceBetween: 24
                }
            }
        });

        function setActiveTab(index) {
            tabs.forEach(function (tab, i) {
                if (i === index) {
                    tab.classList.add('is-active');
                    showTab(tab);
                } else {
                    tab.classList.remove('is-active');
                }
            });
        }

        function updateOffsets() {
            updateCarouselOffsets(block, 'sv-showcase', swiper, container);
        }

        swiper.on('slideChange', function () {
            setActiveTab(swiper.activeIndex);
        });

        swiper.on('resize', updateOffsets);

        tabs.forEach(function (tab, i) {
            tab.addEventListener('click', function () {
                swiper.slideTo(i);
            });
        });

        updateOffsets();
        setActiveTab(swiper.activeIndex);
    });
}
/**
 * EX-3370. "What makes Speed Vegas unique" carousel (cms block "mainpage_unique").
 * The category labels work as the carousel navigation: a click slides to the
 * matching card and the active label follows the current slide.
 */
function initUniqueBlock() {
    if (typeof Swiper === 'undefined') {
        return;
    }

    $('.sv-unique').each(function () {
        var block = this;
        var container = block.querySelector('.sv-unique__carousel');

        if (!container || container.swiper) {
            return;
        }

        var tabs = Array.prototype.slice.call(block.querySelectorAll('.sv-unique__tab'));
        var showTab = initTabRow(block, 'sv-unique');

        var swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 40,
            speed: 500,
            watchOverflow: true,
            grabCursor: true,
            navigation: {
                nextEl: block.querySelector('.sv-unique__arrow--next'),
                prevEl: block.querySelector('.sv-unique__arrow--prev')
            },
            pagination: {
                el: block.querySelector('.sv-unique__dots'),
                clickable: true
            },
            /* swiper 4 matches breakpoints by max-width */
            breakpoints: {
                600: {
                    spaceBetween: 20
                }
            }
        });

        function setActiveTab(index) {
            tabs.forEach(function (tab, i) {
                if (i === index) {
                    tab.classList.add('is-active');
                    showTab(tab);
                } else {
                    tab.classList.remove('is-active');
                }
            });
        }

        function updateOffsets() {
            updateCarouselOffsets(block, 'sv-unique', swiper, container);
        }

        swiper.on('slideChange', function () {
            setActiveTab(swiper.activeIndex);
        });

        swiper.on('resize', updateOffsets);

        tabs.forEach(function (tab, i) {
            tab.addEventListener('click', function () {
                swiper.slideTo(i);
            });
        });

        updateOffsets();
        setActiveTab(swiper.activeIndex);
    });
}

/**
 * EX-3538. Media and text block (cms block "vegassupercars-page-block-media-text").
 * A Vimeo link on the picture is played in the picture's place. The url is read
 * the way CmsHero reads it: the id and, for an unlisted video, its privacy hash.
 * Any other link is left to the browser.
 */
function initMediaTextVideos() {
    $(document).on('click', '.sv-media-text__media a', function (e) {
        var href = this.getAttribute('href') || '';
        var video = href.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/(\w+))?/i);

        if (!video) {
            return;
        }

        var hash = video[2] || (href.match(/[?&]h=(\w+)/) || [])[1];
        var src = 'https://player.vimeo.com/video/' + video[1] + '?autoplay=1&dnt=1' + (hash ? '&h=' + hash : '');

        e.preventDefault();

        $(this).replaceWith($('<iframe>', {
            src: src,
            title: $(this).find('img').attr('alt') || 'Video',
            allow: 'autoplay; fullscreen; picture-in-picture',
            allowfullscreen: true
        }));
    });
}

/**
 * EX-3414. SV > News & media > "Load more".
 *
 * Asks the paginated endpoint for the next page and appends the cards it
 * returns. The markup comes from the server, rendered from the same partial the
 * first page uses, so a card is defined in one place rather than twice.
 */
(function () {
    var button = document.getElementById('sv-news-load-more');
    var grid = document.getElementById('sv-news-grid');

    if (!button || !grid) {
        return;
    }

    var loading = false;

    button.addEventListener('click', function () {
        if (loading) {
            return;
        }

        loading = true;
        button.disabled = true;
        button.classList.add('is-loading');

        var page = parseInt(button.getAttribute('data-next-page'), 10) || 2;
        var category = button.getAttribute('data-category') || '';
        var url = '/news/page/' + page + '/' + (category ? '?category=' + encodeURIComponent(category) : '');

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('HTTP ' + response.status);
                }

                return response.json();
            })
            .then(function (data) {
                if (data.html) {
                    // insertAdjacentHTML keeps the cards already on the page
                    // untouched, so nothing that has loaded is thrown away.
                    grid.insertAdjacentHTML('beforeend', data.html);
                }

                if (data.hasMore) {
                    button.setAttribute('data-next-page', String(page + 1));
                } else {
                    button.hidden = true;
                }
            })
            .catch(function () {
                // Leave the button usable: a failed page is worth retrying, and
                // the reader keeps everything already on screen.
                button.classList.add('is-error');
            })
            .then(function () {
                loading = false;
                button.disabled = false;
                button.classList.remove('is-loading');
            });
    });
})();

/**
 * EX-3414. SV > News & media > category tab row.
 *
 * The row scrolls sideways when the categories do not fit. On touch there is no
 * scrollbar to say so, hence the arrow — which only appears while there is
 * something left to scroll to.
 */
(function () {
    var list = document.querySelector('.sv-news__tab-list');
    var next = document.getElementById('sv-news-tabs-next');

    if (!list || !next) {
        return;
    }

    function overflow() {
        return list.scrollWidth - list.clientWidth;
    }

    function update() {
        // 1px of slack: scrollWidth and clientWidth disagree by a fraction on
        // fractional device pixel ratios even when nothing overflows
        next.hidden = overflow() <= 1 || list.scrollLeft >= overflow() - 1;
    }

    next.addEventListener('click', function () {
        list.scrollBy({ left: Math.round(list.clientWidth * 0.7), behavior: 'smooth' });
    });

    list.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    // a filtered page opens on its own category, which may sit off the edge.
    // Measured against the list rather than through offsetLeft, which is
    // relative to whichever ancestor happens to be positioned and would drag
    // the row sideways when the first tab is already the active one.
    var active = list.querySelector('.sv-news__tab.is-active');

    if (active && overflow() > 1) {
        var listBox = list.getBoundingClientRect();
        var tabBox = active.getBoundingClientRect();

        if (tabBox.left < listBox.left || tabBox.right > listBox.right) {
            list.scrollLeft += tabBox.left - listBox.left - 16;
        }
    }

    update();
})();

/**
 * EX-3414. SV > News & media > "Other news" row.
 *
 * A scroller rather than a carousel: swiping already works without script, so
 * the arrows only nudge it along and grey themselves out at either end. The
 * phone shows dots instead of arrows, which double as a way to jump.
 */
(function () {
    var track = document.getElementById('sv-article-related-track');

    if (!track) {
        return;
    }

    var arrows = document.querySelectorAll('.sv-article-related__arrow');
    var dots = document.querySelectorAll('.sv-article-related__dot');

    /** How far one card sits from the next, measured rather than assumed. */
    function step() {
        var first = track.firstElementChild;

        if (!first) {
            return track.clientWidth;
        }

        var second = first.nextElementSibling;

        return second
            ? second.getBoundingClientRect().left - first.getBoundingClientRect().left
            : first.getBoundingClientRect().width;
    }

    function maxScroll() {
        return track.scrollWidth - track.clientWidth;
    }

    function currentIndex() {
        var last = track.children.length - 1;

        if (last < 0) {
            return 0;
        }

        return Math.max(0, Math.min(last, Math.round(track.scrollLeft / step())));
    }

    function update() {
        var max = maxScroll();
        var index = currentIndex();

        arrows.forEach(function (arrow) {
            var isNext = arrow.getAttribute('data-direction') === 'next';
            // 1px of slack: the two widths disagree by a fraction on
            // fractional device pixel ratios even when nothing overflows
            arrow.disabled = isNext ? track.scrollLeft >= max - 1 : track.scrollLeft <= 1;
        });

        dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
        });
    }

    arrows.forEach(function (arrow) {
        arrow.addEventListener('click', function () {
            var sign = arrow.getAttribute('data-direction') === 'next' ? 1 : -1;

            track.scrollBy({ left: sign * step(), behavior: 'smooth' });
        });
    });

    dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
            track.scrollTo({ left: i * step(), behavior: 'smooth' });
        });
    });

    track.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
})();
/* ==========================================================================
   EX-3427 mega menus.
   A choice is committed by click, Enter or the right arrow. Hover commits too, but
   only after HOVER_INTENT, so a pointer merely crossing a row on its way to Book now
   does not swap the column under it.
   ========================================================================== */
function handleMegaMenus() {
    $('.mega-trigger[data-mega]').each(function () {
        initMegaMenu($(this));
    });
}

function initMegaMenu($trigger) {
    var HOVER_INTENT = 150;
    var CLOSE_ON_SCROLL = true;
    var SCROLL_CLOSE_AT = 50;  // distance scrolled since the menu opened
    var FADE_MS = 180;         // must match the transition on .mega

    var $panel = $('#' + $trigger.data('mega'));
    if (!$panel.length) return;

    var $li = $trigger.closest('li');
    var openTimer = null;
    var selectTimer = null;
    var suppressHover = false; // do not reopen until the pointer has left
    var closeTimer = null;
    var leaveTimer = null;
    var openedAtY = 0;
    var cueSyncs = [];
    var SELECTABLE = '.mega__row, .mega__card, .mega__lap, .mega__btn';

    function placePanel() {
        $panel.css('top', $('header').outerHeight());

        // the wide Supercars panel keeps its place; the narrow ones drop under the entry
        // that opened them
        if (!$panel.hasClass('mega--compact')) {
            return;
        }

        var $inner = $panel.find('.mega__inner');
        var pad = parseFloat($panel.css('padding-left')) || 0;

        $inner.css('margin-left', 0);

        var wanted = $trigger.offset().left - pad;
        var room = $(window).width() - pad * 2 - $inner.outerWidth();

        $inner.css('margin-left', Math.max(0, Math.min(wanted, room)));
    }

    // --- show only the columns on the selected path ----------------------
    function syncCues() {
        for (var i = 0; i < cueSyncs.length; i++) {
            cueSyncs[i]();
        }
    }

    function refresh() {
        var chain = {};
        var $col = $panel.find('.mega__col').first();

        // nothing is chosen for the visitor: a column appears only once the row above it
        // has actually been picked, so the menu grows one step at a time
        while ($col.length) {
            chain[$col.attr('id') || '__root'] = true;

            var $sel = $col.find('[data-opens].is-selected').first();
            if (!$sel.length) break;

            $col = $('#' + $sel.data('opens'));
        }
        if ($col.length) chain[$col.attr('id')] = true;

        $panel.find('.mega__col, .mega__detail').each(function () {
            var id = $(this).attr('id');
            $(this).toggleClass('is-hidden', !!id && !chain[id]);
        });

        $panel.find('[data-opens]').each(function () {
            $(this).attr('aria-expanded', $(this).hasClass('is-selected') ? 'true' : 'false');
        });

        // the menu fills the row only once the car panel is open; while just the lists are
        // showing it stays as wide as they are
        $panel.toggleClass('is-full', $panel.find('.mega__detail').not('.is-hidden').length > 0);

        syncCues();
    }

    function select($el) {
        if (!$el.length || !$el.is('[data-opens]')) return;
        $el.closest('.mega__col').find('[data-opens]').removeClass('is-selected');
        $el.addClass('is-selected');
        refresh();
    }

    // --- opening and closing ---------------------------------------------
    function open() {
        // only one mega menu is open at a time
        $('.mega').not($panel).removeClass('is-open').prop('hidden', true);
        $('.mega-trigger').not($trigger)
            .attr('aria-expanded', 'false')
            .closest('li').removeClass('is-open');

        clearTimeout(closeTimer);
        // unhide first: a hidden panel has no width, and placePanel() measures one
        $panel.prop('hidden', false);
        placePanel();
        // reading a size forces the browser to apply hidden before the class, without
        // which the transition is skipped and the panel appears in one jump
        $panel[0].offsetHeight;
        $panel.addClass('is-open');

        openedAtY = window.pageYOffset;
        $trigger.attr('aria-expanded', 'true');
        $li.addClass('is-open');

        // the panel has only just stopped being hidden: until now scrollHeight equalled
        // clientHeight, so the chevron believed there was nothing to scroll
        syncCues();
    }

    function close() {
        // "unexpand": the columns collapse too, so the menu opens on its first column
        // again rather than where the last visitor left it
        $panel.find('[data-opens].is-selected').removeClass('is-selected');
        refresh();

        $panel.removeClass('is-open');
        $trigger.attr('aria-expanded', 'false');
        $li.removeClass('is-open');

        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
            if (!$panel.hasClass('is-open')) {
                $panel.prop('hidden', true);
            }
        }, FADE_MS);
    }

    function isOpen() {
        return $panel.hasClass('is-open');
    }

    $trigger.on('click', function (e) {
        e.preventDefault();
        if (isOpen()) {
            close();
            suppressHover = true;
        } else {
            open();
        }
    });

    $li.add($panel).on('mouseenter', function () {
        clearTimeout(openTimer);
        if (suppressHover) return;
        openTimer = setTimeout(open, 100);
    }).on('mouseleave', function () {
        clearTimeout(openTimer);
        suppressHover = false;

        // a grace period, because moving from the entry into the panel leaves one before
        // it enters the other; the keyboard keeps the menu open regardless
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(function () {
            if (!isOpen()) return;
            if ($panel[0].contains(document.activeElement)) return;
            close();
        }, 250);
    }).on('mouseenter', function () {
        clearTimeout(leaveTimer);
    });

    // --- hover inside the columns, with intent ----------------------------
    $panel.on('mouseenter', '[data-opens]', function () {
        var $el = $(this);
        clearTimeout(selectTimer);
        selectTimer = setTimeout(function () { select($el); }, HOVER_INTENT);
    }).on('mouseleave', '[data-opens]', function () {
        clearTimeout(selectTimer);
    });

    // a row with no submenu collapses what the row above it had opened: moving from
    // Driving Experiences to Driving Academy should not leave the makes column standing
    $panel.on('mouseenter', '.mega__row:not([data-opens]), .mega__card:not([data-opens])',
        function () {
            var $col = $(this).closest('.mega__col');

            clearTimeout(selectTimer);
            selectTimer = setTimeout(function () {
                $col.find('[data-opens].is-selected').removeClass('is-selected');
                refresh();
            }, HOVER_INTENT);
        });

    // --- click --------------------------------------------------------------
    $panel.on('click', '[data-opens]', function (e) {
        e.preventDefault();
        select($(this));
    });

    // The lap radios share no name, so that Tab stops on every box, and the browser no
    // longer unchecks the others: that, and the hidden field the form sends, are kept
    // here (EX-3551). :has() is not everywhere yet, so the class is kept from JS as well
    $panel.on('change', '.mega__lap input[type="radio"]', function () {
        var $lap = $(this).closest('.mega__lap');

        $lap.addClass('is-selected')
            .siblings('.mega__lap').removeClass('is-selected')
            .find('input[type="radio"]').prop('checked', false);
        $lap.closest('form').find('input[name="laps"]').val(this.value);
    });

    // --- keyboard -----------------------------------------------------------
    $panel.on('keydown', SELECTABLE, function (e) {
        var $el = $(this);
        var $col = $el.closest('.mega__col, .mega__detail');
        var $items = $col.find(SELECTABLE).filter(':visible');
        var i = $items.index($el);

        // The lap boxes are radios, and Enter on a radio submits its form, which took
        // the visitor to the booking. As in the columns, moving does not choose here:
        // Tab and the arrows walk along the row, Space and Enter pick the laps (EX-3551)
        if ($el.is('.mega__lap') && (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Enter')) {
            e.preventDefault();

            if (e.key === 'Enter') {
                $el.find('input').prop('checked', true).trigger('change');
            } else {
                var $laps = $el.siblings('.mega__lap').addBack();
                var j = $laps.index($el) + (e.key === 'ArrowRight' ? 1 : -1);

                $laps.eq(Math.max(0, Math.min(j, $laps.length - 1))).find('input').focus();
            }
            return;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                $items.eq(Math.min(i + 1, $items.length - 1)).focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                $items.eq(Math.max(i - 1, 0)).focus();
                break;
            case 'ArrowRight':
                if ($el.is('[data-opens]')) {
                    e.preventDefault();
                    select($el);
                    $('#' + $el.data('opens')).find(SELECTABLE).filter(':visible').first().focus();
                }
                break;
            case 'ArrowLeft':
                e.preventDefault();
                var $prev = $col.prevAll('.mega__col').first();
                if ($prev.length) $prev.find('.is-selected').first().focus();
                else $trigger.focus();
                break;
            case 'Enter':
            case ' ':
                if ($el.is('[data-opens]')) {
                    e.preventDefault();
                    select($el);
                }
                break;
            case 'Tab':
                // the panel sits after the header in the DOM, so Shift+Tab from its
                // first item would land on the previous nav item, not on its trigger
                if (e.shiftKey &&
                    $panel.find(SELECTABLE).filter(':visible').index($el) === 0) {
                    e.preventDefault();
                    $trigger.focus();
                }
                break;
            case 'Escape':
                e.preventDefault();
                close();
                $trigger.focus();
                break;
        }
    });

    // Tab forward takes focus out of the panel, and it has to close then: otherwise it
    // hangs open over the page while the user is already somewhere underneath it
    function closeIfFocusLeft() {
        setTimeout(function () {
            if (!isOpen()) return;

            var el = document.activeElement;
            if (!el || el === document.body) return;
            if ($panel[0].contains(el) || $li[0].contains(el)) return;

            close();
        }, 0);
    }

    $panel.on('focusout', closeIfFocusLeft);
    $li.on('focusout', closeIfFocusLeft);

    $trigger.on('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open();
            $panel.find(SELECTABLE).filter(':visible').first().focus();
        } else if (e.key === 'Escape') {
            close();
        }
    });

    // --- closing from outside -------------------------------------------------
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) {
            close();
            $trigger.focus();
        }
    });

    $(document).on('click', function (e) {
        if (!isOpen()) return;
        if ($(e.target).closest($panel).length || $(e.target).closest($li).length) return;
        close();
    });

    if (CLOSE_ON_SCROLL) {
        $(window).on('scroll', function () {
            if (isOpen() && Math.abs(window.pageYOffset - openedAtY) > SCROLL_CLOSE_AT) {
                close();
            }
        });
    }

    $(window).on('resize', function () {
        if (isOpen()) placePanel();
    });

    wireScrollCues();
    refresh();

    /**
     * A column with a hidden scrollbar: the chevron and the fade are the only cue that
     * the list runs on. Same approach as Our Garage, turned vertical.
     */
    function wireScrollCues() {
        $panel.find('.mega__scroll').each(function () {
            var scroll = this;
            var $col = $(scroll).closest('.mega__col');
            var $up = $col.find('.mega__cue--up');
            var $down = $col.find('.mega__cue--down');

            if (!$up.length || !$down.length) return;

            function sync() {
                var left = scroll.scrollHeight - scroll.clientHeight - scroll.scrollTop;
                var above = scroll.scrollTop > 1;
                var below = left > 1;

                $up.toggleClass('is-visible', above);
                $down.toggleClass('is-visible', below);
                $col.toggleClass('has-above', above).toggleClass('has-below', below);
            }

            function step(direction) {
                scroll.scrollBy({
                    top: direction * Math.round(scroll.clientHeight * 0.8),
                    behavior: 'smooth'
                });
            }

            $up.on('click', function () { step(-1); });
            $down.on('click', function () { step(1); });

            $(scroll).on('scroll', sync);
            $(window).on('resize', sync);

            cueSyncs.push(sync);
            sync();
        });
    }
}

/* ==========================================================================
   EX-3427 header states.
   While the hero is in view the bar is a gradient over it, after that a solid black
   strip. The header is position: fixed either way, so only the fill changes.
   On a page without a hero the bar is black from the start.
   ========================================================================== */
function handleHeaderStates() {
    var $header = $('header');
    if (!$header.length) return;

    var $hero = $('.hero-video').first();
    var heroBottom = 0;
    var ticking = false;

    function measure() {
        heroBottom = $hero.length ? $hero.offset().top + $hero.outerHeight() : 0;
    }

    function apply() {
        var overHero = heroBottom > 0 &&
            (window.pageYOffset + $header.outerHeight()) < heroBottom;

        $header
            .toggleClass('is-over-hero', overHero)
            .toggleClass('is-stuck', !overHero);

        ticking = false;
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
    }

    measure();
    apply();

    $(window).on('scroll', onScroll);
    $(window).on('resize', function () {
        measure();
        apply();
    });
}

/**
 * EX-3539. Racetrack block (cms block "vegassupercars-page-block-racetrack").
 * The Vimeo link in .sv-racetrack__video becomes the track animation: a muted
 * background player on a loop, mounted when the block comes near the screen. As in
 * the homepage hero (hero_video.php), the player is shown only once the video
 * plays, so a refused autoplay or a blocked player leaves the block's background
 * instead of Vimeo's error screen, and a visitor who asked the system for less
 * motion gets no video. The url is read the way CmsHero reads it: the id and, for
 * an unlisted video, its privacy hash.
 */
function initRacetrackVideos() {
    var $boxes = $('.sv-racetrack__video').has('a[href*="vimeo.com"]');

    if (!$boxes.length) {
        return;
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        $boxes.remove();
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                mountRacetrackVideo(entry.target);
            }
        });
    }, { rootMargin: '300px 0px' });

    $boxes.each(function () {
        observer.observe(this);
    });
}

function mountRacetrackVideo(box) {
    var href = $(box).find('a[href*="vimeo.com"]').attr('href');
    var video = href.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/(\w+))?/i);

    if (!video) {
        return;
    }

    var hash = video[2] || (href.match(/[?&]h=(\w+)/) || [])[1];
    var frame = document.createElement('iframe');

    // autopause=0: Vimeo pauses its other players on the page, the hero among them
    frame.src = 'https://player.vimeo.com/video/' + video[1] +
        '?background=1&autoplay=1&loop=1&muted=1&autopause=0&dnt=1' + (hash ? '&h=' + hash : '');
    frame.title = '';
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    $(box).empty().append(frame);

    function fail() {
        box.classList.remove('is-playing');
        $(frame).remove();
    }

    loadVimeoPlayerApi(function () {
        var player = new Vimeo.Player(frame);

        player.on('timeupdate', function (data) {
            if (data && data.seconds > 0.1) {
                box.classList.add('is-playing');
            }
        });

        // The loop parameter is not always honoured, so restart explicitly.
        player.on('ended', function () {
            player.setCurrentTime(0).then(function () {
                return player.play();
            })['catch'](function () {});
        });

        player.on('error', fail);
        player.ready().then(function () {
            return player.play();
        })['catch'](fail);
    });
}

/**
 * Vimeo's player.js, loaded once for the page; the hero may have added it already.
 */
function loadVimeoPlayerApi(callback) {
    var src = 'https://player.vimeo.com/api/player.js';
    var script = document.querySelector('script[src="' + src + '"]');

    if (window.Vimeo && window.Vimeo.Player) {
        callback();
        return;
    }

    if (!script) {
        script = document.createElement('script');
        script.src = src;
        script.async = true;
        document.body.appendChild(script);
    }

    script.addEventListener('load', callback);
}
